import { h, Component } from 'preact'
import { CountUp as Count } from 'countup.js'

/** @jsx h */

export default class CountUp extends Component {
  constructor (props) {
    super(props)
    const { className, style, endVal, ...options } = props
    this.formattingFn = new Count(null, null, options).formattingFn
  }

  componentDidMount() {
    this.startAnimation()
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.redraw || nextProps.endVal != this.props.endVal
  }

  componentDidUpdate() {
    this.startAnimation()
  }

  startAnimation () {
    const { className, style, endVal, ...options } = this.props

    if (this.countUpInstance)
      this.countUpInstance.update(endVal)
    else {
      this.countUpInstance = new Count(this.spanElement, endVal, options)
      this.countUpInstance.start()
    }
  }

  render() {
    const { className, style, endVal, startVal, ...options } = this.props

    return (
      <span
        className={className}
        ref={span => this.spanElement = span}
        style={style}
      >
        {this.formattingFn(startVal, options)}
      </span>
    )
  }
}
